import React from 'react';
import s from './style.module.scss';
import cx from 'classnames';
import { useRouter } from 'next/router';
import { time_format } from '../../../../utils';
import H5Image from 'web-materials/dist/esm/components/common/H5Image';

const ArticleItem = (props) => {
  const { picture, tags, title, updated_time, author, avatar, isHead } = props;
  const router = useRouter();

  return (
    <div
      className={cx(s.wrapper, { [s.head]: isHead })}
      onClick={() =>
        router.push({
          pathname: `/articles/${encodeURIComponent(title.replace(/[^a-zA-Z]/g, '-'))}`,
          query: { id: props.id },
        })
      }
    >
      <div className={s.headPicWrapper}>
        <H5Image type="origin" src={picture} className={s.headPic} />
      </div>
      <div className={s.rightContent}>
        <div className={s.tagWrapper}>
          {tags?.slice(0, 3)?.map((tag) => (
            <div key={tag} className={s.tag}>
              {tag}
            </div>
          ))}
        </div>
        <div className={s.title}>{title}</div>
        <div className={s.authorContent}>
          <div className={s.avatar}>
            <H5Image src={avatar} className={s.avatarImg} />
          </div>
          <div>
            <div className={s.auther}>{author}</div>
            <div className={s.updateTime}>{time_format(updated_time)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticleItem;
